<template>
	<div class="operation_box">
		<div class="operation_item">
			<AccessRestrictedButton v-if="isClearingAllowed"
									button-name-key="seller.payments.table.operation.clearing"
									button-class="md-primary"
									:permission="enumDef.permissions.SellerManualPayment"
									@click="requestClearing"
			></AccessRestrictedButton>
		</div>
	</div>
</template>

<script>
import {enumDef} from "@/common/enumDefs";
import AccessRestrictedButton from "@/components/templates/common/permissions/AccessRestrictedButton";

export default {
	components: {
		AccessRestrictedButton
	},
	data() {
		return {
			enumDef: enumDef
		};
	},
    methods: {
        requestClearing() {
			this.params.requestClearing(this.params.data);

        }
    },
    computed: {
        isClearingAllowed() {
            let { data } = this.params;
            let {
	            sellerToTransferSettlementRecordId,
                sellerToBuyerPaymentStatus,
	            buyerToSellerPaymentStatus
            } = data;

            return sellerToTransferSettlementRecordId
				&& !enumDef.paymentStatus.isSettled(sellerToBuyerPaymentStatus)
				&& buyerToSellerPaymentStatus !== enumDef.paymentStatus.Revoked;
        }
    }
};
</script>